export var CanonicalLogType;
(function (CanonicalLogType) {
    CanonicalLogType["SecretWordGiver"] = "SecretWordGiver";
    CanonicalLogType["GameIndex"] = "GameIndex";
})(CanonicalLogType || (CanonicalLogType = {}));
;
//# sourceMappingURL=DebugTypes.js.map